<template>
  <div class="active-page">
    <div class="detail-main">
      <div class="title">{{ detail.title }}</div>
      <div class="summary">活动概述：{{ detail.summary }}</div>
      <div class="rangeDate">
        活动时间：{{ detail.startDate }}——{{ detail.endDate }}
      </div>
      <div class="content" v-html="detail.content"></div>
    </div>

    <div class="list">
      <side-block-title name="近期活动" />
      <div class="items" v-if="list">
        <div class="article-item" v-for="item in list" :key="item.auto_id">
          <a @click="flushCom(item)">
            <img :src="imgSiteUrl + item.img_url" alt="" />
            <!-- <img
              :src="
                imgSiteUrl +
                'M00/00/05/wKgAA2Ie70eAE3VUAACtImv1nBY509.jpg'
              "
              alt=""
            /> -->
          </a>
          <div class="title">
            <router-link
              :to="{ path: '/activity', query: { id: item.auto_id } }"
            >
              {{ item.title }}
            </router-link>
          </div>
        </div>
      </div>
      <div v-else class="items">
        <a-empty>
          <template #description>
            <span> 您还没有创建论文集 </span>
          </template>
        </a-empty>
      </div>
    </div>

    <div class="clear"></div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, toRefs, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import SideBlockTitle from "../components/SideBlockTitle.vue";
import config from "../until/configs";
import Http from "../until/http";

export default defineComponent({
  components: { SideBlockTitle },
  setup() {
    const state = reactive({
      detail: {},
      list: [],
      imgSiteUrl: config.imgSiteUrl,
    });

    const route = useRoute();
    const router = useRouter();

    const flushCom = (item) => {
      router.push({
        path: "/activity",
        query: { id: item.auto_id },
      });
    };
    watch(
        () => route.query.id,
        (newPath,oldPath) => {
          if(newPath!==oldPath){
              router.go(0)
          }
        }
      );
    onMounted(() => {
      let id = route.query.id;
      Http.getActivityDetail({ id }).then((res) => {
        if (res) {
          Object.assign(state, {
            detail: res,
          });
        }
      });
      Http.getActivityList({ type: 1 }).then((res) => {
        if (res && res.list) {
          Object.assign(state, {
            list: res.list,
          });
        }
      });
    });

    return {
      ...toRefs(state),
      flushCom,
    };
  },
});
</script>

<style lang="scss">
.active-page {
  width: 1200px;
  margin: 0 auto;
  padding: 12px 0;
  .detail-main {
    width: 880px;
    float: left;
    background: #fff;
    border-radius: 2px;
    padding: 20px;
    .title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .summary {
      line-height: 24px;
    }

    .rangeDate {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;
    }

    .content {
      font-size: 16px;
      line-height: 30px;
      margin: 30px 0;
      ul,
      ol {
        padding-left: 24px;
      }
      ul {
        list-style: disc;
      }
      h1 {
        font-size: 20px;
        font-weight: bold;
      }
      h2 {
        font-size: 18px;
      }
      img {
        max-width: 100%;
      }
      blockquote {
        margin: 0 0 10px;
        padding: 15px 20px;
        background-color: #f1f2f3;
        border-left: 5px solid #ccc;
        color: #666;
        font-style: italic;
      }
    }
  }
  .list {
    width: 308px;
    background: #fff;
    float: right;
    border-radius: 2px;
    .items {
      padding: 20px 15px 10px;
      .article-item {
        width: 100%;
        overflow: hidden;
        position: relative;
        padding: 0;
        margin: 0 0 16px;
        img {
          width: 278px;
          height: 170px;
        }
        .title {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          line-height: 23px;
          padding-top: 10px;
        }
      }
    }
  }
}
</style>